import { FiChevronDown, FiChevronUp } from 'react-icons/fi';

export const WATCHLIST_QUOTES_COLUMNS = [
  { align: 'left' as const, key: 'symbol' as const, label: 'Symbol' },
  { align: 'right' as const, key: 'price' as const, label: 'Price' },
  { align: 'right' as const, key: 'change' as const, label: 'Change' },
  { align: 'right' as const, key: 'changePercent' as const, label: 'Change %' },
  { align: 'right' as const, key: 'volume' as const, label: 'Volume' },
  { align: 'right' as const, key: 'marketCap' as const, label: 'Market Cap' },
  { align: 'right' as const, key: 'alerts' as const, label: 'Alerts' },
];

export type WatchlistQuotesColumn = (typeof WATCHLIST_QUOTES_COLUMNS)[number];
export type WatchlistQuotesSortKey = WatchlistQuotesColumn['key'];
export type WatchlistQuotesSortDir = 'asc' | 'desc';

export const WATCHLIST_QUOTES_HEADER_LABEL_CLASS =
  'inline-flex h-[18px] items-center gap-1 border-0 bg-transparent p-0 font-[inherit] text-[11px] font-semibold uppercase leading-none tracking-wide';

export const WATCHLIST_PANEL_TOOLBAR_CLASS =
  'flex flex-col gap-2 border-b border-slate-200 bg-white px-4 py-3 sm:flex-row sm:items-center sm:justify-between';

export const PORTFOLIO_TABLE_CELL_CLASS = 'px-4 py-3';
export const PORTFOLIO_TABLE_HEADER_CELL_CLASS = 'px-4 py-2.5';
export const PORTFOLIO_TABLE_NUMERIC_CLASS = 'w-0 whitespace-nowrap';

export const watchlistQuotesHeaderCellClass = (align: WatchlistQuotesColumn['align']): string =>
  `px-4 py-2.5 ${align === 'right' ? `text-right ${PORTFOLIO_TABLE_NUMERIC_CLASS}` : 'min-w-[16rem] text-left'}`;

export const watchlistQuotesHeaderLabelClass = (
  align: WatchlistQuotesColumn['align'],
  isActive: boolean,
): string =>
  `${WATCHLIST_QUOTES_HEADER_LABEL_CLASS} ${align === 'right' ? 'flex-row-reverse' : ''} ${
    isActive ? 'text-slate-700' : 'text-slate-500'
  }`;

export const WatchlistQuotesSortGlyphs = ({
  isActive,
  sortDir,
}: {
  isActive: boolean;
  sortDir?: WatchlistQuotesSortDir;
}) => (
  <span className="inline-flex h-[18px] w-3 shrink-0 flex-col items-center justify-center leading-none text-slate-400">
    <FiChevronUp
      size={10}
      className={isActive && sortDir === 'asc' ? 'text-slate-600 opacity-100' : 'opacity-40'}
    />
    <FiChevronDown
      size={10}
      className={`-mt-0.5 ${isActive && sortDir === 'desc' ? 'text-slate-600 opacity-100' : 'opacity-40'}`}
    />
  </span>
);

export const WatchlistQuotesStaticTableHead = () => (
  <thead className="sticky top-0 z-10">
    <tr className="border-b border-slate-200 bg-white text-[11px]">
      {WATCHLIST_QUOTES_COLUMNS.map(column => (
        <th key={column.key} className={watchlistQuotesHeaderCellClass(column.align)}>
          <span className={watchlistQuotesHeaderLabelClass(column.align, false)}>
            {column.label}
            <WatchlistQuotesSortGlyphs isActive={false} />
          </span>
        </th>
      ))}
    </tr>
  </thead>
);
